export const CURRICULUM = {
  ERRORS: {
    loadingCurriculumTool: "There was an error loading this curriculum",
    xmlFileType: "Please select xml file type",
    loadingCurriculum: "error loading curriculums",
    deployingCurriculum: "Error deploying the curriculum",
    uploadingCurriculum: "Error uploading the curriculum"
  }
};

export const BEDROCK_METADATA = {
  LEVELS: ["KS2", "KS3", "KS4", "KS5", "S1", "S2", "S3", "S4", "S5", "S6"],
  SUBJECTS: [
    "Biology",
    "Chemistry",
    "English Language",
    "English Literature",
    "Geography",
    "History",
    "Physics",
    "Science"
  ]
};

export const BEDROCK_OPTIONS_MAP: Record<string, string[]> = {
  Subject: BEDROCK_METADATA.SUBJECTS,
  Level: BEDROCK_METADATA.LEVELS
};
export const BEDROCK_EXTENSION_MAP = {
  keyStage: "Subject",
  schoolLevel: "Level"
} as const;
